import { Injectable } from '@angular/core';
import { DocumentService } from './document.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class DocumentDisplayerService {

  constructor(
    private readonly documentService: DocumentService,
    private readonly toastr: ToastrService,
  ) { }

  // errorMessages lets a caller supply its own toast text for specific HTTP statuses (e.g. { 409: "..." }).
  // Statuses it does not cover fall back to the default messages below.
  displayDocument(url: string, format: string, documentName: string, errorMessages?: { [httpStatus: number]: string }) {

    this.documentService.getDocument(url, format, documentName).subscribe(
      (x) => {
        URL.createObjectURL(x);
      },
      (err) => {
        const customMessage = errorMessages?.[err.status];
        if (customMessage) {
          this.toastr.error(customMessage, "Error Loading Document");
        } else if (err.status == 404) {
          this.toastr.error("Document has been deleted due to a data retention policy.", "Error Loading Document");
        } else {
          this.toastr.error("Sorry, an error occurred while loading your document.", "Error Loading Document");
        }
      }
    );
  }
}
